export enum MemberRouterNameEnum {
  /** 臻还卡、臻乐卡小卡路由 */
  PackageDetail = 'package-detail',
  /** 加速卡 */
  Accelerate = 'accelerate-right-page',
  /** 臻享卡新版 - api */
  ZHENXIANG_CARD_API = 'zhenxiang-card',
  /** 臻享卡端内 */
  ZHENXIANG_CARD = 'zhenxiang-card-hb',
  /** 臻享会员(目前只有端内场景，在资金路由阶段已经确定了只会在客户端内分发) */
  ZHENXIANG_MEMBER_CARD = 'zhenxiang-member-card',
  /** 渠道权益 */
  CHANNEL_ELSE = 'channel-package-list'
}
